/**************************************************
 * Nombre:       SeleccionadorOpciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, RadioGroup, Typography} from "@mui/material";
import Tarjeta_Empresa_Envio from "../Tarjetas/Tarjeta_Empresa_Envio";
import {theme} from "../../Tema";


const SeleccionadorOpciones = ({opciones = [], escogida, setOpcionEscogida, yaCotizo = false}) => {


    return (
        <Grid
            container
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            size={12}
            sx={{pl: 1}}
        >

            <RadioGroup
                onChange={(e) => setOpcionEscogida(e.target.value)}
                value={escogida?.token}
            >
                <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="flex-start"
                    size={12}
                    spacing={2}
                    sx={{px: 1}}
                >

                    {opciones.map((item, index) => {
                        return (
                            <Grid key={`wsq${index}`} item container size={12}
                                  sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Empresa_Envio item={item} index={index} escogida={escogida}/>
                            </Grid>
                        )
                    })}



                    {yaCotizo && opciones.length <= 0 &&

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 12, md: 12}} sx={{mt: 2}}>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                                <Typography sx={{
                                    textAlign: 'center',
                                    color: theme.palette.primary.main,
                                    fontSize: 18,
                                    fontWeight: 600,
                                    lineHeight: 1.1
                                }}>No hemos encontrado una opcion de envio hasta tu domicilio</Typography>
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                                {/*  <img src={triste} width={80} height={'auto'}/>*/}
                            </Grid>

                            <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                                <Typography
                                    sx={{
                                        textAlign: 'center',
                                        color: theme.palette.primary.main,
                                        fontSize: 16,
                                        fontWeight: 400,
                                        lineHeight: 1.1
                                    }}
                                >Comunicate con nosotros antes de realizar tu pedido, lo
                                    resolveremos</Typography>
                            </Grid>


                        </Grid>

                    }

                </Grid>
            </RadioGroup>


        </Grid>
    )

}
export default SeleccionadorOpciones

